import { CTAColorVariant } from '~/components/shared/CTAButton';
import { WALMART_URLS } from '../../../config/urls';

export const primaryCTALinks = [
  WALMART_URLS.PLUS_PLANS,
  WALMART_URLS.PLUS_PLANS,
  WALMART_URLS.PLUS_STUDENT_SIGNUP,
  WALMART_URLS.PLUS_ASSIST_SIGNUP,
] as const;

export interface MembershipTypeProps {
  variant?: 'default' | 'holiday';
  membershipCards?: {
    type?: string;
    price?: string;
    period?: string;
    discount?: string;
    icon?: string;
    disclaimer?: string;
    disclaimerLink?: string;
    pillText?: string;
    isPopular?: boolean;
    frontContent?: {
      title: string;
      description: string;
      frontFlipText: string;
    };
    backContent?: {
      title: string;
      description: string;
      backFlipText: string;
    };
  }[];
  headline?: string;
  subheadline?: string;
  disclaimer?: {
    text?: string;
    link?: string;
  };
  primaryCTA?: {
    text: string;
    link: string;
    variant: CTAColorVariant;
  };
  secondaryCTA?: {
    text: string;
    link: string;
    variant: CTAColorVariant;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const DEFAULT_PROPS: MembershipTypeProps = {
  variant: 'default',
  membershipCards: [
    {
      type: 'Annual',
      price: '98',
      period: 'Year',
      discount: '-37%',
      icon: 'annual-icon.svg',
      disclaimer:
        '_BOLD_Annual membership: _BOLD_ Compared to monthly fee of $12.95 for 12 months.',
      disclaimerLink: '',
      pillText: 'Most Popular',
      isPopular: true,
      frontContent: {
        title: 'Annual',
        description: 'Save more with our best value plan',
        frontFlipText: 'Learn more',
      },
      backContent: {
        title: 'Annual',
        description:
          'Get all Walmart+ benefits for a full year at our best price',
        backFlipText: 'Back',
      },
    },
    {
      type: 'Monthly',
      price: '12.95',
      period: 'Month',
      discount: '',
      icon: 'monthly-icon.svg',
      disclaimer: '',
      disclaimerLink: '',
      pillText: 'Most Popular',
      isPopular: false,
      frontContent: {
        title: 'Monthly',
        description: 'Flexible month-to-month plan',
        frontFlipText: 'Learn more',
      },
      backContent: {
        title: 'Monthly',
        description:
          'All Walmart+ benefits with the flexibility to cancel anytime',
        backFlipText: 'Back',
      },
    },
    {
      type: 'Student',
      price: '49',
      period: 'Year',
      discount: '-50%',
      icon: 'student-icon.svg',
      disclaimer:
        '_BOLD_Walmart+ Student:_BOLD_ For eligible college & grad students. Not available to Walmart+ Assist members, members that have upgraded to Paramount+ Premium plan or current Walmart+ members who are participating in select third-party offers or participating in a Walmart Cash membership offer. Terms apply. Subject to change.',
      disclaimerLink: '',
      pillText: 'Most Popular',
      isPopular: false,
      frontContent: {
        title: 'Student',
        description: 'Special savings for students',
        frontFlipText: 'Learn more',
      },
      backContent: {
        title: 'Student',
        description:
          'Verify your student status to unlock 50% off annual membership',
        backFlipText: 'Back',
      },
    },
    {
      type: 'Assist',
      price: '49',
      period: 'Year',
      discount: '-50%',
      icon: 'assist-icon.svg',
      disclaimer:
        '_BOLD_Walmart+ Assist:_BOLD_ For customers eligible for government assistance. Not available to Walmart+ Student members, members that have upgraded to Paramount+ Premium plan or current Walmart+ members who are participating in select third-party offers or participating in a Walmart Cash membership offer. Terms apply. Subject to change.',
      disclaimerLink: '',
      pillText: 'Most Popular',
      isPopular: false,
      frontContent: {
        title: 'Assist',
        description: 'For those who qualify for government assistance',
        frontFlipText: 'Learn more',
      },
      backContent: {
        title: 'Assist',
        description:
          'Verify eligibility for government assistance programs to save 50%',
        backFlipText: 'Back',
      },
    },
  ],
  headline: 'Choose a plan that fits your needs',
  subheadline:
    'Just create an account, enter your info & enjoy your free trial.',
  disclaimer: {
    text: '_BOLD_Free 30-day trial: _BOLD_ One free trial per member. ',
    link: '',
  },
  primaryCTA: {
    text: 'Claim your free trial',
    link: primaryCTALinks[0],
    variant: 'primary-yellow' as CTAColorVariant,
  },
  secondaryCTA: {
    text: '',
    link: 'https://www.walmart.com/plus/plans',
    variant: 'text-link' as CTAColorVariant,
  },
};

export default DEFAULT_PROPS;
